import React, { useContext } from 'react';
import LensTwoToneIcon from '@mui/icons-material/LensTwoTone';
import { Typography, SvgIcon, IconButton } from '@mui/material';
import { useHistory } from 'react-router-dom';
import OnlineStatusContext from '../contexts/OnlineStatusContext';

const ConnectionStatusBlip = (props) => {
    const {online} = useContext(OnlineStatusContext);


    if (online) {
        return (
            <div id="connectionStatusBlip">
                <div style={{display: 'inline-flex', verticalAlign: 'middle'}}>
                    <LensTwoToneIcon fontSize={"large"} style={{fill: 'green', fontSize: '3rem' }} />
                </div>
                <Typography style={{color:'white'}} component="span">{'\u00A0'}Online</Typography>
            </div>
        );
    } else {

        return (
            <div id="connectionStatusBlip">
                <div style={{display: 'inline-flex', verticalAlign: 'middle'}}>
                    <LensTwoToneIcon fontSize={"large"} style={{fill: 'red', fontSize: '3rem' }} />
                </div>
                <Typography style={{color:'white'}} component="span">{'\u00A0'}Offline</Typography>
            </div>
        );
    }
};

const ConnectedBackButtonIcon = () => {
    return (
        <SvgIcon style={{fontSize: '2.5rem'}}>
            <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="chevron-circle-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path fill="#1EB980" d="M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zM256 472c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm-86.6-224.5l115.1-115c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L209 256l99.5 99.5c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0l-115.1-115c-4.6-4.8-4.6-12.4.1-17.1z"></path>
            </svg>
        </SvgIcon>
    );
};

const DisconnectedBackButtonIcon = () => {
    return (
        <SvgIcon style={{fontSize: '2.5rem'}}>
            <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="chevron-circle-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path fill="red" d="M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zM256 472c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm-86.6-224.5l115.1-115c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L209 256l99.5 99.5c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0l-115.1-115c-4.6-4.8-4.6-12.4.1-17.1z"></path>
            </svg>
        </SvgIcon>
    );
};

const ConnectionAwareBackButton = (props) => {
    const history = useHistory();
    const {online} = useContext(OnlineStatusContext);
    const handleOnClick = () => {
        history.goBack();
    };

    if (online) {
        return (
            <IconButton
                edge="start"
                aria-label="connection status"
                onClick={handleOnClick}
                size="large">
                <div style={{display: 'inline-flex', verticalAlign: 'middle'}} >
                    <ConnectedBackButtonIcon />
                </div>
            </IconButton>
        );
    } else {
        return (
            <IconButton
                edge="start"
                aria-label="connection status"
                onClick={handleOnClick}
                size="large">
                <div style={{display: 'inline-flex', verticalAlign: 'middle'}} >
                    <DisconnectedBackButtonIcon />
                </div>
            </IconButton>
        );

    }
};

export { ConnectionStatusBlip, ConnectionAwareBackButton };